import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import type {CategoryOrder} from '../constants';

/**
 * `setCategoryOrder` request params
 * (what is used to send to server)
 */
export interface SetCategoryOrderRequestOptions {
	ids: number[];
	orderType?: CategoryOrder;
	/** reordering is submitted as a `job` to the `job queue` */
	threaded?: boolean;
}

/**
 * `setCategoryOrder` request
 * (what gets sent to the server)
 */
export type SetCategoryOrderRequest = [
	SetCategoryOrderRequestOptions['ids'],
	Required<SetCategoryOrderRequestOptions>['orderType'],
	Required<SetCategoryOrderRequestOptions>['threaded'],
];

/**
 * `setCategoryOrder` response
 * (what comes back from the server)
 */
export type SetCategoryOrderResponse = SuccessResponse<null>;

/**
 * `setCategoryOrder` result
 * (what is utilized from the server response)
 */
export type SetCategoryOrderResult = boolean;

export const setCategoryOrderEndpoint = 'setCategoryOrder';

/**
 * Update category order (on a level)
 * @param fetchParams Fetch params
 */
export const setCategoryOrder = async ({
	ids,
	orderType = 0,
	threaded = false,
}: SetCategoryOrderRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: SetCategoryOrderRequest = [ids, orderType, threaded];

	return client
		.post<SetCategoryOrderResponse>(setCategoryOrderEndpoint, requestParams)
		.then((response) => {
			return true;
		});
};
export default setCategoryOrder;
